import Vue from "vue";
import VueRouter from "vue-router";
import FormsContainer from "../views/forms_container/FormsContainer.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "FormsContainer",
    component: FormsContainer
  }
];

const router = new VueRouter({
  routes
});

export default router;
